import React from 'react';

function SpriteEl({
	id,
	type = "icon",
	wrap = false,
	onclick = () => {}
}) {
	// Construct the sprite path dynamically with the correct path
	const isLocalhost = process.env.NODE_ENV === 'development';
	const basePath = isLocalhost ? '/build' : '/wp-content/themes/lipskaya/build';
	const spritePath = `${basePath}/icon/icon.svg#${id}`;

	// SVG content
	const svgContent = (
		<svg onClick={onclick}>
			<use xlinkHref={spritePath}></use>
		</svg>
	);

	// Wrap SVG in a span if `wrap` is true
	return wrap ? <span>{svgContent}</span> : svgContent;
}

export default SpriteEl;